/**
 * autocomplete-object.js
 * 
 * this variant expects the provided options to be an array of objects with 'id' and 'name' props.
 * selected values are set as the option object while custom string values are converted into the expected
 * option shape as described above, omitting 'id' since that is only available for existing options.
 */

import React from 'react';
import Autocomplete from './autocomplete';


export default function AutocompleteObject(props) {
  return (
    <Autocomplete
      {...props}
      getOptionLabel={option => {
        return typeof option === 'string' ? option : option?.name || '';
      }}
      isOptionEqualToValue={(option, value) => {
        return value.id
          ? value.id === option.id
          : value.name === option.name;
      }}
      makeValue={name => ({ name })}
    />
  );
}